/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-undef */
/* eslint-disable import/no-unresolved */
/* eslint-disable no-unused-expressions */
/* eslint-disable array-callback-return */
import React, { useState, useEffect } from "react";
import { observable, action } from "mobx";
import { useHistory } from "react-router-dom";
import { observer } from "mobx-react";
import ConstantObj from "Static/constant";
import Button from "Components/common/Button";
import Utils from "Utils/utils";
import { tagsStoreData } from "Stores/TagsData";
import PersonalInformation from "./contact/PersonalInformation";
import CompanyInformation from "./contact/CompanyInformation";
import ContactNotes from "./contact/ContactNotes";
import LocationInformation from "./contact/LocationInformation";
import SocialLinks from "./contact/SocialLinks";
import ContactTags from "./contact/ContactTags";
import ContactCustomFields from "./contact/ContactCustomFields";
import { SequenceUtils } from "Utils/SequenceUtils";
import { userDetail } from "Stores/userDetail";

class AddSingleContactPopupState {
  @observable showPopup = false;
  @observable submitCallback = () => {};
  @observable successCallback = () => {};
  @observable sequenceData = {};
  @observable tokenList = [];
  @observable isContactPage = false;

  @action
  setShowPopup = val => {
    this.showPopup = val;
    if (val) {
      document.getElementsByTagName("body")[0].classList.add("scrollHidden");
    } else {
      this.popupValues = this.defaultPopupValue;
      document.getElementsByTagName("body")[0].classList.remove("scrollHidden");
    }
  };

  @action
  setIsContactPage = value => {
    this.isContactPage = value;
  };

  @action
  setSequenceData = val => {
    this.sequenceData = val;
  };

  @action
  setTokenList = val => {
    this.tokenList = val;
  };

  @action
  setSubmitCallback = val => {
    this.submitCallback = val;
  };

  @action
  setSuccessCallback = val => {
    this.successCallback = val;
  };
}

const addSingleContactPopupState = new AddSingleContactPopupState();

const SectionCard = ({ title, children, className = "" }) => (
  <section className={`editPopupCard ${className}`}>
    <header className="editPopupCardHeader">
      <h3 className="editPopupCardTitle">{title}</h3>
    </header>
    <div className="editPopupCardBody">{children}</div>
  </section>
);

const AddSingleContactPopup = observer(() => {
  const history = useHistory();

  const { emailValidationCredits = 0, emailValidationEnabled = false } =
    userDetail.userFeatureFlag || {};

  const [inputVal, setInputVal] = useState({});
  const [buttonLoader, setButtonLoader] = useState(false);
  const [showTagDropDown, setShowTagDropDown] = useState(false);
  const [tagList, setTagList] = useState([]);
  const [selectedTags, setSelectedTags] = useState(inputVal.contactTags);
  const [errMsg, setErrMsg] = useState("");
  const [isBlockedDomain, setIsBlockedDomain] = useState(false);

  const changeInputVal = (id, data, flag) => {
    if (flag === "customFields") {
      const stateObj = { ...inputVal };
      const customFields = stateObj["customFields"];
      if (customFields) {
        customFields[id] = data;
        setInputVal(stateObj);
      } else {
        const tempObj = {};
        tempObj[id] = data;
        stateObj.customFields = tempObj;
        setInputVal(stateObj);
      }
    } else {
      const stateObj = { ...inputVal };
      if (id === "email") {
        errMsg && setErrMsg("");
        checkBlockedDomain(data);
      }
      stateObj[id] = data;
      setInputVal(stateObj);
    }
  };

  const checkBlockedDomain = (email = "") => {
    setIsBlockedDomain(false);
    let splitdomain = email?.split("@") || [];
    if (
      splitdomain?.length > 1 &&
      userDetail?.blockedDomainList?.includes(splitdomain?.[1])
    ) {
      setIsBlockedDomain(true);
    }
  };

  const processContactAndAddToSequence = async () => {
    setButtonLoader(true);
    const payload = getAddContactPayload();
    try {
      const success = await addSingleContactPopupState.submitCallback(
        payload,
        addSingleContactPopupState.sequenceData,
        addSingleContactPopupState.successCallback
      );
      if (success) {
        closeAction();
      } else {
        setButtonLoader(false);
      }
    } catch (e) {
      setButtonLoader(false);
    }
  };

  const submitAction = async ev => {
    if (ev?.target?.checkValidity()) {
      ev.preventDefault();

      const emailValue = ev?.target["email"]?.value || "";
      const linkedinValue = ev?.target["linkedinId"]?.value || "";

      const hasEmail = emailValue && ConstantObj.emailRegex.test(emailValue);
      const hasLinkedIn = linkedinValue && linkedinValue.trim().length > 0;
      const hasNameAndCompany = Boolean(
        inputVal?.firstName?.trim() &&
          inputVal?.lastName?.trim() &&
          (inputVal?.company?.trim() || inputVal?.website?.trim())
      );

      if (!hasEmail && !hasLinkedIn && !hasNameAndCompany) {
        setErrMsg(
          "Please enter an email address, a LinkedIn URL, or first name, last name and company"
        );
        return;
      }

      if (hasEmail && isBlockedDomain) {
        setErrMsg("Entered domain is blocked");
        return;
      }

      if (hasEmail && !ConstantObj.emailRegex.test(emailValue)) {
        setErrMsg("Please enter a valid email address");
        return;
      }

      if (addSingleContactPopupState?.sequenceData?.emailValidationEnabled) {
        if (
          emailValidationEnabled &&
          emailValidationCredits < 1 &&
          !addSingleContactPopupState?.isContactPage
        ) {
          SequenceUtils.promptEmailValidationNoCredits(
            1,
            history,
            processContactAndAddToSequence,
            closeAction,
            "sequence"
          );
          return;
        }
      }
      await processContactAndAddToSequence();
    } else {
      ev?.target?.reportValidity();
    }
  };

  const getAddContactPayload = () => {
    if (inputVal && Object.keys(inputVal).length) {
      const payload = {};
      const contact = {};
      if (selectedTags?.length) {
        const extractedTagsArray = Utils.extractTagNameFromList(selectedTags);
        payload.contactTags = extractedTagsArray;
      }
      contact.firstName = inputVal.firstName || null;
      contact.lastName = inputVal.lastName || null;
      contact.email = inputVal.email || null;
      contact.linkedinId = Utils.removeHttpFromString(
        inputVal.linkedinId || null
      );
      if (inputVal?.mobilePhone?.length) {
        contact.mobilePhone = [inputVal.mobilePhone];
      }
      if (inputVal?.otherPhone?.length) {
        contact.otherPhone = [inputVal.otherPhone];
      }
      if (inputVal?.phone?.length) {
        contact.phone = [inputVal.phone];
      }
      contact.company = inputVal.company || null;
      contact.jobTitle = inputVal.jobTitle || null;
      contact.industry = inputVal.industry || null;
      contact.street = inputVal.street || null;
      contact.city = inputVal.city || null;
      contact.state = inputVal.state || null;
      contact.country = inputVal.country || null;
      contact.zipCode = inputVal.zipCode || null;
      contact.website = inputVal.website || null;
      contact.facebook = inputVal.facebook || null;
      contact.twitter = inputVal.twitter || null;
      contact.contactNotes = inputVal.contactNotes || null;
      contact.customFields =
        Utils.addNullForEmptyObject(inputVal.customFields) || null;
      payload.contacts = [contact];
      return payload;
    }
  };

  const closeAction = () => {
    errMsg && setErrMsg("");
    setInputVal({});
    setButtonLoader(false);
    setShowTagDropDown(false);
    setSelectedTags([]);
    addSingleContactPopupState.setShowPopup(false);
  };

  const addSelectedTagsInTagList = (tagList, existingTags) => {
    if (existingTags && existingTags.length) {
      tagList &&
        tagList.map(obj => {
          const { value } = obj;
          if (value && existingTags.includes(value)) {
            obj.checked = true;
          }
        });
    }
    setTagList(tagList);
  };

  useEffect(() => {
    if (tagsStoreData.tagsData) {
      addSelectedTagsInTagList(
        Utils.createObjWithoutRef(tagsStoreData.tagsData),
        null
      );
    }
  }, [tagsStoreData.tagsData]);

  if (!addSingleContactPopupState.showPopup) {
    return "";
  }

  return (
    <div className="popupWrapper editContactPopup editContactPopupV2">
      <div className="common-popup-mask editPopupMask" onClick={closeAction} />
      <div className="confirmation-popup common-popup editPopupShell">
        <form
          className="popup-wrap editPopupForm"
          onSubmit={e => submitAction(e)}
          autoComplete="off"
        >
          {showTagDropDown && (
            <div
              className="transparentOverlay"
              onClick={() => setShowTagDropDown(false)}
            />
          )}

          <header className="editPopupHeader">
            <div className="editPopupHeaderLeft">
              <h2 className="editPopupTitle">Add Contact</h2>
              <p className="editPopupSubtitle">
                Fill in the contact&apos;s details and click Upload to add them.
              </p>
            </div>
            <button
              type="button"
              className="editPopupClose"
              onClick={closeAction}
              title="Close"
              aria-label="Close"
            >
              <i className="material-icons">close</i>
            </button>
          </header>

          <div className="editPopupBody">
            <SectionCard title="Personal Information">
              <PersonalInformation
                changeInputVal={changeInputVal}
                inputVal={inputVal}
                tokenList={addSingleContactPopupState.tokenList}
                errMsg={errMsg}
                isContactPage={addSingleContactPopupState?.isContactPage || false}
              />
            </SectionCard>

            <div className="editPopupRow companyAndNotes">
              <SectionCard
                title="Company Information"
                className="companySection"
              >
                <CompanyInformation
                  changeInputVal={changeInputVal}
                  inputVal={inputVal}
                  tokenList={addSingleContactPopupState.tokenList}
                  isContactPage={
                    addSingleContactPopupState?.isContactPage || false
                  }
                />
              </SectionCard>
              <SectionCard title="Contact Notes" className="notesSectionCard">
                <ContactNotes
                  changeInputVal={changeInputVal}
                  inputVal={inputVal}
                />
              </SectionCard>
            </div>

            <SectionCard title="Location">
              <LocationInformation
                changeInputVal={changeInputVal}
                inputVal={inputVal}
                tokenList={addSingleContactPopupState.tokenList}
              />
            </SectionCard>

            <SectionCard title="Social Links">
              <SocialLinks
                changeInputVal={changeInputVal}
                inputVal={inputVal}
                tokenList={addSingleContactPopupState.tokenList}
              />
            </SectionCard>

            <SectionCard title="Contact Tags" className="tagsSectionCard">
              <ContactTags
                tagsList={tagList}
                setTagList={setTagList}
                showTagDropDown={showTagDropDown}
                setShowTagDropDown={setShowTagDropDown}
                selectedTags={selectedTags}
                setSelectedTags={setSelectedTags}
              />
            </SectionCard>

            <SectionCard
              title="Custom Fields"
              className="customFieldsSectionCard"
            >
              <ContactCustomFields
                changeInputVal={changeInputVal}
                customFieldsValue={inputVal.customFields || {}}
                tokenList={addSingleContactPopupState.tokenList}
              />
            </SectionCard>
          </div>

          <footer className="editPopupFooter">
            <button
              type="button"
              className="editPopupCancelBtn"
              onClick={closeAction}
            >
              Cancel
            </button>
            <Button
              type="submit"
              btnText="Upload"
              className={`positive-btn editPopupSaveBtn ${
                buttonLoader ? "loading" : ""
              }`}
              loader={buttonLoader}
              needExtraDom={false}
            />
          </footer>
        </form>
      </div>
    </div>
  );
});

export { AddSingleContactPopup, addSingleContactPopupState };
export default AddSingleContactPopup;
